module.exports = __webpack_public_path__ + "img/marketer-unactive.c2a2228.svg";